// extracted by mini-css-extract-plugin
module.exports = {"breakoutContainer":"styles_breakoutContainer__0NwH3"};